import React, { useMemo } from "react";
import { ClipLoader } from "react-spinners";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";

// Árvore de triagem (master): Transportadora → categoria, só contagens.
// O nó da transportadora expande/recolhe; clicar em qualquer linha seleciona
// o recorte que a grade (detalhe) abre. Um doc com vários motivos conta em
// cada categoria, então a soma dos filhos pode passar o total do pai.

const INDENT_PX = 18;

function flattenVisible(arvore, expanded) {
  const out = [];
  arvore.forEach((t) => {
    out.push(t);
    if (expanded.has(t.key) && t.children) {
      t.children.forEach((c) => out.push(c));
    }
  });
  return out;
}

const thStyle = {
  textAlign: "right",
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: AUTOPILOT_COLORS.muted,
  padding: "0.4rem 0.6rem",
  borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
  whiteSpace: "nowrap",
};

const tdNum = {
  textAlign: "right",
  fontSize: "0.84rem",
  padding: "0.4rem 0.6rem",
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
};

function NumCell({ value, color }) {
  const zero = !value;
  return (
    <td style={{ ...tdNum, color: zero ? AUTOPILOT_COLORS.muted : color, fontWeight: zero ? 400 : 700 }}>
      {Number(value || 0).toLocaleString("pt-BR")}
    </td>
  );
}

export default function ImportacaoArvore({ arvore, expanded, onToggle, selectedKey, onSelect, loading }) {
  const visible = useMemo(() => flattenVisible(arvore || [], expanded), [arvore, expanded]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "2.2rem 0" }}>
        <ClipLoader size={26} color="var(--theme-accent)" />
      </div>
    );
  }

  if (!arvore || arvore.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "1.6rem 0", color: AUTOPILOT_COLORS.muted, fontSize: "0.85rem" }}>
        Nenhuma pendência no escopo atual.
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ ...thStyle, textAlign: "left" }}>Transportadora / motivo</th>
            <th style={thStyle}>Pendências</th>
            <th style={thStyle}>Ação</th>
            <th style={thStyle}>Aguardando</th>
            <th style={thStyle}>Recebido</th>
          </tr>
        </thead>
        <tbody>
          {visible.map((node) => {
            const isTransp = node.nivel === 0;
            const hasChildren = isTransp && node.children && node.children.length > 0;
            const isExpanded = expanded.has(node.key);
            const isSelected = node.key === selectedKey;

            return (
              <tr
                key={node.key}
                onClick={() => onSelect(node)}
                style={{
                  cursor: "pointer",
                  background: isSelected ? AUTOPILOT_COLORS.insetSurfaceActive : "transparent",
                  borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
                  borderLeft: `3px solid ${isSelected ? AUTOPILOT_COLORS.accent : "transparent"}`,
                }}
              >
                <td
                  style={{
                    padding: "0.4rem 0.6rem",
                    paddingLeft: 8 + node.nivel * INDENT_PX,
                    fontSize: isTransp ? "0.88rem" : "0.82rem",
                    fontWeight: isTransp ? 700 : 500,
                    color: isTransp ? AUTOPILOT_COLORS.title : AUTOPILOT_COLORS.text,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    onClick={(e) => {
                      if (hasChildren) {
                        e.stopPropagation();
                        onToggle(node.key);
                      }
                    }}
                    style={{
                      display: "inline-block",
                      width: 16,
                      color: AUTOPILOT_COLORS.muted,
                      cursor: hasChildren ? "pointer" : "default",
                    }}
                  >
                    {hasChildren ? (isExpanded ? "▼" : "▶") : isTransp ? "" : "•"}
                  </span>
                  {node.label}
                </td>
                <NumCell value={node.total} color={AUTOPILOT_COLORS.title} />
                <NumCell value={node.acionavel} color={AUTOPILOT_COLORS.statusDanger} />
                <NumCell value={node.dependencia} color={AUTOPILOT_COLORS.statusWarning} />
                <NumCell value={node.naoProcessado} color={AUTOPILOT_COLORS.accent} />
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
